__turbopack_context__.v({
  "container": "DonationItems-module__3Wo64a__container",
  "initialItemWrapper": "DonationItems-module__3Wo64a__initialItemWrapper",
  "stack": "DonationItems-module__3Wo64a__stack",
});
